import { SVGIconComponent } from './types';
import HighlightOffOutlined from '@mui/icons-material/HighlightOffOutlined';

export const ActionDisable: SVGIconComponent = ({ className, color, style }) => (
  <HighlightOffOutlined
    style={{
      color: color ?? '#848484',
      fontSize: '24px',
      ...style
    }}
    className={className}
  ></HighlightOffOutlined>
);
